import { OrderDetailsMainContainer } from '@/modules/Orders';

const OrdersDetails = (): JSX.Element => <OrderDetailsMainContainer />;

export default OrdersDetails;
